/**
 * @fileoverview DELETE handler for the "/companies/:company_id/email_self_serve/:app_group_id/sending_domain/:domain_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdEmailSelfServeSendingDomainDomainIdCacheKeys } from "./constants";
import type { DeleteSendingDomainProps } from "./types";

export const deleteSendingDomain = reactQueryMutationAdapter(
  companiesCompanyIdEmailSelfServeSendingDomainDomainIdCacheKeys,
  (props: DeleteSendingDomainProps): Promise<void> => {
    const { companyId, appGroupId, domainId } = props;

    return fetch(
      `/companies/${companyId}/email_self_serve/${appGroupId}/sending_domain/${domainId}`,
      "DELETE",
      undefined,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
